module.exports = __webpack_public_path__ + "assets/svg/Icons/32/user-blue-dbe88d.svg";